(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-bar"] && !Shopify.designMode) return;
  try {
     
const WebiTimer = setInterval(countDown, 1000);
function countDown() {
  const countdownSections = document.querySelectorAll('.wb_product_countdown');
  countdownSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
 
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-about"] && !Shopify.designMode) return;
  try {
    
  class HomeAbout extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('.home-about__card').forEach((button) => {
        const dialog = this.querySelector(`#${button.getAttribute('aria-controls')}`);
        button.addEventListener('click', () => {
          const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
          this.previousBodyStyles = {
            overflow: document.body.style.overflow,
            paddingRight: document.body.style.paddingRight,
          };
          const paddingRight = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
          document.body.style.overflow = 'hidden';
          document.body.style.paddingRight = `${paddingRight + scrollbarWidth}px`;
          dialog.showModal();
        });
        dialog.querySelector('.home-about__dialog-close').addEventListener('click', () => dialog.close());
        let pointerStartedOnBackdrop = false;
        dialog.addEventListener('pointerdown', (event) => {
          pointerStartedOnBackdrop = event.target === dialog;
        });
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog && pointerStartedOnBackdrop) dialog.close();
          pointerStartedOnBackdrop = false;
        });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousBodyStyles.overflow;
          document.body.style.paddingRight = this.previousBodyStyles.paddingRight;
          button.focus({ preventScroll: true });
        });
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('.home-about__dialog[open]').forEach((dialog) => dialog.close());
    }
  }
  if (!customElements.get('home-about')) customElements.define('home-about', HomeAbout);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-hero-video')) {
    customElements.define(
      'home-hero-video',
      class HomeHeroVideo extends HTMLElement {
        connectedCallback() {
          this.desktopMediaQuery = window.matchMedia('(min-width: 992px)');
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.videos = [...this.querySelectorAll('.home-hero-video__video')];

          this.handleStateChange = this.updatePlayback.bind(this);
          this.handlePlaying = this.onPlaying.bind(this);
          this.handleError = this.onError.bind(this);

          this.desktopMediaQuery.addEventListener('change', this.handleStateChange);
          this.reducedMotionQuery.addEventListener('change', this.handleStateChange);
          document.addEventListener('visibilitychange', this.handleStateChange);

          this.videos.forEach((video) => {
            video.muted = true;
            video.defaultMuted = true;
            video.addEventListener('playing', this.handlePlaying);
            video.addEventListener('error', this.handleError);
          });

          this.updatePlayback();
        }

        disconnectedCallback() {
          this.desktopMediaQuery?.removeEventListener('change', this.handleStateChange);
          this.reducedMotionQuery?.removeEventListener('change', this.handleStateChange);
          document.removeEventListener('visibilitychange', this.handleStateChange);

          this.videos?.forEach((video) => {
            video.removeEventListener('playing', this.handlePlaying);
            video.removeEventListener('error', this.handleError);
          });
        }

        getActiveVideo() {
          const device = this.desktopMediaQuery.matches ? 'desktop' : 'mobile';
          return this.querySelector(`.home-hero-video__video--${device}`);
        }

        onPlaying(event) {
          if (event.currentTarget === this.getActiveVideo()) {
            this.classList.add('is-playing');
          }
        }

        onError(event) {
          if (event.currentTarget === this.getActiveVideo()) {
            this.classList.remove('is-playing');
          }
        }

        updatePlayback() {
          const activeVideo = this.getActiveVideo();
          const videoChanged = this.activeVideo !== activeVideo;
          const reduceMotion = this.reducedMotionQuery.matches;

          if (videoChanged || reduceMotion) {
            this.classList.remove('is-playing');
          }
          this.activeVideo = activeVideo;

          this.videos.forEach((video) => {
            if (video !== activeVideo) {
              video.pause();
              video.preload = 'none';
            }
          });

          if (!activeVideo || reduceMotion || document.hidden) {
            activeVideo?.pause();
            return;
          }

          if (activeVideo.preload !== 'auto') {
            activeVideo.preload = 'auto';
          }

          const playPromise = activeVideo.play();
          if (playPromise) {
            playPromise.catch(() => this.classList.remove('is-playing'));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layout-header"]) return;
  try {
    
  if (!customElements.get('layout-header')) {
    customElements.define('layout-header', class LayoutHeader extends HTMLElement {
      connectedCallback() {
        this.menuButton = this.querySelector('.layout-header__menu-toggle');
        this.headerBar = this.querySelector('.layout-header__bar');
        this.drawer = this.querySelector('.layout-header__drawer');
        this.closeButton = this.querySelector('.layout-header__drawer-close');
        this.announcementHost = this.querySelector('[data-drawer-announcement]');
        this.closeTimer = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.updateDrawerLayout = this.updateDrawerLayout.bind(this);
        this.updateScrollbarCompensation = this.updateScrollbarCompensation.bind(this);
        this.pageResizeObserver = new ResizeObserver(this.updateScrollbarCompensation);
        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.handleDrawerLinkClick = this.handleDrawerLinkClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.menuButton.addEventListener('click', this.openMenu);
        this.closeButton.addEventListener('click', this.closeMenu);
        this.drawer.addEventListener('click', this.handleDrawerLinkClick);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.updateDrawerLayout);
        document.addEventListener('keydown', this.handleKeydown);
        this.copyAnnouncement();
        this.handleScroll();
        this.updateDrawerLayout();
      }

      disconnectedCallback() {
        this.menuButton.removeEventListener('click', this.openMenu);
        this.closeButton.removeEventListener('click', this.closeMenu);
        this.drawer.removeEventListener('click', this.handleDrawerLinkClick);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.updateDrawerLayout);
        document.removeEventListener('keydown', this.handleKeydown);
        window.clearTimeout(this.closeTimer);
        this.pageResizeObserver.disconnect();
        document.body.classList.remove('layout-header-menu-open');
        document.body.style.removeProperty('--layout-header-scrollbar-width');
        this.headerBar.inert = false;
      }

      handleScroll() {
        this.classList.toggle('is-solid', window.scrollY > 48);
      }

      copyAnnouncement() {
        const announcement = document.querySelector('.annoucehome');
        if (!announcement) {
          this.announcementHost.hidden = true;
          return;
        }

        const clone = announcement.cloneNode(true);
        const idMap = new Map();
        clone.querySelectorAll('[id]').forEach((element, index) => {
          const originalId = element.id;
          const cloneId = `LayoutHeaderAnnouncement-${index}`;
          idMap.set(originalId, cloneId);
          element.id = cloneId;
        });
        clone.querySelectorAll('[aria-controls], [aria-labelledby]').forEach((element) => {
          ['aria-controls', 'aria-labelledby'].forEach((attribute) => {
            const value = element.getAttribute(attribute);
            if (idMap.has(value)) element.setAttribute(attribute, idMap.get(value));
          });
        });
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
          element.removeAttribute('data-shopify-editor-block');
        });
        this.announcementHost.replaceChildren(clone);
        this.announcementHost.hidden = false;
      }

      updateDrawerLayout() {
        this.updateScrollbarCompensation();
        const announcementHeight = this.announcementHost.hidden ? 0 : this.announcementHost.offsetHeight;
        this.style.setProperty('--layout-header-announcement-height', `${announcementHeight}px`);
      }

      updateScrollbarCompensation() {
        if (!document.body.classList.contains('layout-header-menu-open')) return;

        const hasPageOverflow = document.documentElement.scrollHeight > window.innerHeight;
        const scrollbarWidth = hasPageOverflow ? this.drawer.offsetWidth - this.drawer.clientWidth : 0;
        const width = `${scrollbarWidth}px`;
        if (document.body.style.getPropertyValue('--layout-header-scrollbar-width') !== width) {
          document.body.style.setProperty('--layout-header-scrollbar-width', width);
        }
      }

      handleKeydown(event) {
        if (!this.classList.contains('is-menu-open') || this.classList.contains('is-closing')) return;

        if (event.key === 'Escape') {
          this.closeMenu();
          return;
        }

        if (event.key === 'Tab') {
          const focusableElements = [...this.drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
            .filter((element) => element.offsetParent !== null);
          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (!firstElement || !lastElement) return;

          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      }

      handleDrawerLinkClick(event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!(event.target instanceof Element)) return;

        const link = event.target.closest('a[href]');
        if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

        const destination = new URL(link.href, window.location.href);
        const current = window.location;
        if (!destination.hash || destination.origin !== current.origin || destination.pathname !== current.pathname || destination.search !== current.search) return;

        event.preventDefault();
        this.closeMenu(() => {
          if (current.hash === destination.hash) {
            document.getElementById(decodeURIComponent(destination.hash.slice(1)))?.scrollIntoView();
          } else {
            current.assign(destination.href);
          }
        });
      }

      openMenu() {
        if (this.classList.contains('is-menu-open') && !this.classList.contains('is-closing')) return;
        window.clearTimeout(this.closeTimer);
        this.classList.remove('is-closing');
        this.classList.add('is-menu-open');
        document.body.classList.add('layout-header-menu-open');
        this.pageResizeObserver.observe(document.body);
        this.menuButton.setAttribute('aria-expanded', 'true');
        this.menuButton.setAttribute('aria-label', this.menuButton.dataset.closeLabel);
        this.drawer.setAttribute('aria-hidden', 'false');
        this.headerBar.inert = true;
        this.updateDrawerLayout();
        requestAnimationFrame(() => this.closeButton.focus({ preventScroll: true }));
      }

      closeMenu(onClosed) {
        if (!this.classList.contains('is-menu-open') || this.classList.contains('is-closing')) return;
        this.classList.add('is-closing');
        this.menuButton.setAttribute('aria-expanded', 'false');
        this.menuButton.setAttribute('aria-label', this.menuButton.dataset.openLabel);

        const closeDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300;
        this.closeTimer = window.setTimeout(() => {
          this.classList.remove('is-menu-open', 'is-closing');
          this.pageResizeObserver.disconnect();
          document.body.classList.remove('layout-header-menu-open');
          document.body.style.removeProperty('--layout-header-scrollbar-width');
          this.drawer.setAttribute('aria-hidden', 'true');
          this.drawer.scrollTop = 0;
          this.headerBar.inert = false;
          this.menuButton.focus({ preventScroll: true });
          if (typeof onClosed === 'function') onClosed();
        }, closeDuration);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wbquickview"]) return;
  try {
    
            class ProductModal extends ModalDialog {
                constructor() {
                super();
                }

                hide() {
                super.hide();
                }

                show(opener) {
                super.show(opener);
                this.showActiveMedia();
                }

                showActiveMedia() {
                this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                    element.classList.remove('active');
                    }
                )
                const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
                const activeMediaTemplate = activeMedia.querySelector('template');
                const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
                activeMedia.classList.add('active');
                activeMedia.scrollIntoView();

                const container = this.querySelector('[role="document"]');
                container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

                if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                    activeMedia.loadContent();
                }
            }

            customElements.define('product-modal', ProductModal);
            
  } catch(e) { console.error(e); }
})();
})();
